/* eslint-disable */

export function showMoney(){
  var moneyShown = {
	  "pennies" : Math.floor(Math.random() * 4),
	  "nickels" : Math.floor(Math.random() * 4),
	  "dimes" : Math.floor(Math.random() * 4),
	  "quarters" : Math.floor(Math.random() * 4),
	  "dollars" : Math.floor(Math.random() * 4)
  };
  return moneyShown;
}

export function moneyShownToTotal(moneyShown){
	return (moneyShown.pennies * 0.01) + (moneyShown.nickels * 0.05) + (moneyShown.dimes * 0.10) + 
         (moneyShown.quarters * 0.25) + (moneyShown.dollars * 1.00);
}

export function moneyShownToString(moneyShown){
  var total = moneyShownToTotal(moneyShown).toFixed(2);
  var message = [];
  if(moneyShown.dollars > 1) message.push(`${moneyShown.dollars} dollars`);
  if(moneyShown.dollars === 1) message.push(`${moneyShown.dollars} dollar`);
  
  if(moneyShown.quarters > 1) message.push(`${moneyShown.quarters} quarters`);
  if(moneyShown.quarters === 1) message.push(`${moneyShown.quarters} quarter`);

  if(moneyShown.dimes > 1) message.push(`${moneyShown.dimes} dimes`);
  if(moneyShown.dimes === 1) message.push(`${moneyShown.dimes} dime`);

  if(moneyShown.nickels > 1) message.push(`${moneyShown.nickels} nickels`);
  if(moneyShown.nickels === 1) message.push(`${moneyShown.nickels} nickel`);

  if(moneyShown.pennies > 1) message.push(`${moneyShown.pennies} pennies`);
  if(moneyShown.pennies === 1) message.push(`${moneyShown.pennies} penny`);

  message = message.join(" + ");
  message += ` = \$${total}`;

  return message;
}

export function checkAnswer(moneyShown, answer){
	return ((parseFloat(answer).toFixed(2)) == moneyShownToTotal(moneyShown).toFixed(2));
}

export function answerConfirm(correctCheck){
    if(correctCheck){
      return ("Correct!");
    }
    else {
      return ("Sorry...");
    }
  }



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/money/lib/money.js
 **/